module.exports = __webpack_public_path__ + "img/icons for DS Logistik SPIM.-11.cd6da790.svg";